import apiClient from 'services/_infra/apiClient';

export async function GetIFrameSource(deviceId) {
  try {
    const response = await apiClient.get(`/getMaintenanceUrls/${deviceId}`);

    console.log('Response from IFrameSource:', response);
    return response.data.result;
  } catch (error) {
    console.error('Error in GetIFrameSource');
  }
}

export async function GetPowerMaintenanceURL(deviceId) {
  try {
    const response = await apiClient.get(`/getGroupMaintenanceUrls_v2/${deviceId}`);

    // console.log(
    //   "clicked button Response from GetPowerMaintenanceURL:",
    //   response
    // );
    return response.data.result;
  } catch (error) {
    console.error('clicked button Error in GetPowerMaintenanceURL:', error);
  }
}

export async function GetTechBridgeMaintenanceURL(deviceId) {
  try {
    const response = await apiClient.get(`/getDeviceMaintenanceUrls/${deviceId}`);

    // console.log(
    //   "clicked button Response from GetTechBridgeMaintenanceURL:",
    //   response
    // );

    return response.data.result;
  } catch (error) {
    console.error('clicked button Error in GetTechBridgeMaintenanceURL:', error);
  }
}
